import { CSSProperties } from 'react';
import { GroupBase, OptionProps, StylesConfig } from 'react-select';
import { CustomStylesArgs, ISelectStyleProps } from './types';
import { Obj } from 'types/common';

const textStyle: CSSProperties = {
  // lineHeight: '32px',
  color: '#171E37',
  fontFamily: '"Ubuntu", sans-serif',
  fontSize: 18,
  fontWeight: 400,
};

export const defaultSelectStyles: ISelectStyleProps = {
  selectStyle: {
    minWidth: 150,
    maxWidth: 200,
    flex: 1,
  },
  containerStyles: {
    marginBottom: 0,
    backgroundColor: 'white',
    borderRadius: 32,
  },
  controlStyles: {
    background: 'white',
    borderRadius: 32,
    whiteSpace: 'nowrap',
  },
};

export const menuHeight = 560;

export function getCustomStyles<T extends Obj>({
  isError,
  controlStyles,
}: CustomStylesArgs): StylesConfig<T, false | true> {
  return {
    container: (provided) => {
      return {
        ...provided,
        marginBottom: 24,
        width: '100%',
        ...controlStyles?.containerStyles,
      };
    },
    control: (provided, state) => {
      return {
        ...provided,
        ...textStyle,
        minHeight: 42,
        border: `1px solid ${isError ? '#E73331' : state.isFocused ? 'hsl(0, 0%, 70%)' : '#ECECEC'} `,
        boxShadow: 'none',
        background: 'rgba(245, 245, 245, 0.5)',
        borderRadius: 8,
        cursor: 'pointer',
        paddingLeft: 24,
        '&:hover': {
          borderColor: 'hsl(0, 0%, 70%)',
        },
        '&[aria-disabled="true"]': {
          pointerEvents: 'auto',
          cursor: 'not-allowed',
        },
        ...controlStyles?.controlStyles,
      };
    },
    option: (provided, state: OptionProps<T, false | true, GroupBase<T>>) => {
      return {
        ...provided,
        ...textStyle,
        backgroundColor: state.isSelected ? '#eef0f6' : state.isFocused ? '#eef0f6' : '',
      };
    },
    valueContainer: (provided) => {
      return {
        ...provided,
        ...textStyle,
        padding: 0,
        alignItems: 'center',
        margin: '4px 0',
      };
    },
    indicatorSeparator: () => ({
      display: 'none',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      paddingRight: 16,
      '& div': {
        padding: 0,
      },
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: '#102340',
      '&:hover': {
        color: '#102340',
      },
    }),
    input: (provided) => ({
      ...provided,
      ...textStyle,
      margin: 0,
      padding: 0,
    }),
    placeholder: (provided) => ({
      ...provided,
      ...textStyle,
      fontSize: 16,
      lineHeight: '32px',
      color: 'rgba(23, 30, 55, 0.3)',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    }),
    singleValue: (provided) => ({
      ...provided,
      ...textStyle,
    }),
    menu: (provided) => ({
      ...provided,
      height: 'fit-content',
      maxHeight: menuHeight,
      zIndex: 5,
      width: '95%',
      left: 4,
      marginBottom: 20,
      ...controlStyles?.menuStyles,
    }),
    menuList: (provided) => ({
      ...provided,
      height: 'fit-content',
      maxHeight: menuHeight,
    }),
    multiValue: (provided) => {
      return {
        ...provided,
        ...textStyle,
        backgroundColor: '#f5f5f5',
        border: '1px solid #ECECEC',
        borderRadius: 8,
        fontSize: 16,
        lineHeight: '16px',
        padding: '5px 8px',
        height: '100%',
        alignItems: 'center',
        margin: 3,
        columnGap: 8,
        ...controlStyles?.multiValueStyle,
      };
    },
    multiValueLabel: (provided) => ({
      ...provided,
      fontSize: 12,
      lineHeight: '16px',
      cursor: 'default',
    }),
    multiValueRemove: (provided, state) => ({
      ...provided,
      display: state.data.isFixed ? 'none' : 'contents',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    }),
  };
}
